import type { Key } from 'react';
import { atom } from 'jotai';
const baseTimelineExpandedAnnotationIdsAtom = atom<Set<Key>>(new Set<Key>());

// Timeline row expand/collapse state, independent of selection. Writing a `rowId` toggles it.
export const timelineExpandedAnnotationIdsAtom = atom((get): ReadonlySet<Key> => get(baseTimelineExpandedAnnotationIdsAtom), (get, set, rowId: Key) => {
  const next = new Set(get(baseTimelineExpandedAnnotationIdsAtom));
  if (next.has(rowId)) {
    next.delete(rowId);
  } else {
    next.add(rowId);
  }
  set(baseTimelineExpandedAnnotationIdsAtom, next);
});

// Write-only: idempotently adds `rowIds` to the expansion set (used to expand rows on select).
// No-ops when all ids are already expanded, so a redundant sync never rebuilds descriptors.
export const expandAnnotationIdsAtom = atom(null, (get, set, rowIds: ReadonlyArray<Key>) => {
  const current = get(baseTimelineExpandedAnnotationIdsAtom);
  const idsToAdd = rowIds.filter(id => !current.has(id));
  if (idsToAdd.length === 0) return;
  const next = new Set(current);
  for (const id of idsToAdd) {
    next.add(id);
  }
  set(baseTimelineExpandedAnnotationIdsAtom, next);
});